// composables/useCourse.js
import { ref } from 'vue';

const selectedCourse = ref(null);

export function useCourse() {
  return {
    selectedCourse,
  };
}